export default "__VITE_ASSET__By16xPBV__"